import DiscussionModel from "../models/DiscussionModel";

export default class Handler {

    public constructor(
        protected dispatch: (action: string, params?: any) => void,
        protected fetch: (method: string, params: { [key: string]: any }) => Promise<{
            error?: string,
            result?: any,
        }>,
    ) {
    }

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        return model;
    }

}